import React from 'react';

import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import IBDIcon from '@totem/styles/Icon';
import { UserProfile } from '@totem/types/user';

export const getSubMenuSurveys = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: 'surveyinstances',
      title: 'Management',
      label: 'Management',
      description: 'Survey Management',
      route: '/dashboard/surveyinstances',
      icon: <IBDIcon name="Survey" />,
      hasPermissions: () => {
        return permissions.survey.hasPermissions(userProfile);
      },
    },
    {
      key: 'auditsv2',
      title: 'Audits',
      label: 'Audits',
      description: 'Policy Audits',
      route: '/dashboard/policyaudits/v2',
      icon: <IBDIcon name="Policy" />,
      hasPermissions: () => {
        return permissions.survey.hasPermissions(userProfile);
      },
    },
    {
      key: 'policiesv2',
      title: 'Policies',
      label: 'Policies',
      description: 'Policies',
      route: '/dashboard/policies/v2',
      icon: <IBDIcon name="Policy" />,
      hasPermissions: () => {
        return permissions.survey.hasPermissions(userProfile);
      },
    },
    {
      key: 'findingsv2',
      title: 'Analysis',
      label: 'Analysis',
      description: 'Audit Analysis',
      route: '/dashboard/findings/policyaudits/v2',
      icon: <IBDIcon name="Finding" />,
      hasPermissions: () => {
        return permissions.survey.hasPermissions(userProfile);
      },
    },
    {
      key: 'templates',
      title: 'Templates',
      label: 'Templates',
      description: 'Survey Template Management',
      route: '/dashboard/surveytemplates',
      icon: <IBDIcon name="Survey Template" />,
      hasPermissions: () => {
        return (
          permissions.survey.hasPermissions(userProfile) &&
          permissions.internal.hasPermissions(userProfile)
        );
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
